import type { Contract } from '../types';

/**
 * The company sent the contract again after the customer answered the earlier
 * draft (sent it back): a changed agreement for the customer to review and
 * sign. Read from the existing draft timestamps, no status of its own; every
 * new round counts (ClickUp 869fg9feb).
 */
export const isRevisedDraft = (
  contract: Pick<Contract, 'draftStatus' | 'draftSentAt' | 'draftRespondedAt' | 'companySigned' | 'personSigned'>
): boolean => {
  if (contract.draftStatus !== 'draft_sent' && contract.draftStatus !== 'signed_by_company') return false;
  if (contract.companySigned && contract.personSigned) return false;
  if (!contract.draftSentAt || !contract.draftRespondedAt) return false;
  return new Date(contract.draftSentAt).getTime() > new Date(contract.draftRespondedAt).getTime();
};
